export const loginInitialState = {
  createAccountMessage: "",
  userEmailforOtp: "",
};

export const loginReducer = (state, action) => {
  switch (action.type) {
    case "SET_CREATE_ACCOUNT_MESSAGE":
      return { ...state, createAccountMessage: action.payload };
    case "SET_USER_EMAIL_FOR_OTP":
      return { ...state, userEmailforOtp: action.payload };
    case "SET_USER_PHONE_FOR_OTP":
      return { ...state, userPhoneforOtp: action.payload };
    default:
      return state;
  }
};
